import MicroModal from 'micromodal';
import Flickity from 'flickity';
import 'flickity-as-nav-for';

import { eventBus, withPlugins, domEvents, device } from '@spon/plugins';

function ShowcaseGalleryModal({ node, plugins: { addEvents, device } }) {
	const header = document.getElementById('header');
	let mainCarouselNode = false;
	let mainCarousel = false;
	let navCarouselNode = false;
	let navCarousel = false;
	let activeVideo = false;

	// init Carousels, after Sprig content loaded..
	function initCarousel(startingIndexId) {
		mainCarousel = new Flickity(mainCarouselNode, {
			cellAlign: 'left',
			cellSelector: '[data-slide]',
			contain: false,
			draggable: 1,
			pageDots: false,
			pauseAutoPlayOnHover: false,
			wrapAround: true,
			prevNextButtons: true,
			initialIndex: startingIndexId,
			arrowShape:
				'M100 42.3H24.3l34.2-31.6-8.2-8.9L0 48.3l50.1 49.9 8.6-8.6-35.2-35.2H100V42.3z',
			on: {
				ready: function () {
					setActiveVideo(this.cells[0].element);
				},
				change: function (index) {
					setActiveVideo(this.cells[index].element);
				},
			},
		});

		function setActiveVideo(element) {
			if (!element) return;
			if (activeVideo) stopCurrentVideo();
			activeVideo = element.querySelector('iframe') ?? false;
		}

		if (navCarouselNode) {
			navCarousel = new Flickity(navCarouselNode, {
				asNavFor: mainCarouselNode,
				cellAlign: 'center',
				cellSelector: '[data-slide]',
				contain: true,
				draggable: 1,
				groupCells: true,
				pageDots: false,
				pauseAutoPlayOnHover: false,
				wrapAround: false,
				prevNextButtons: false,
				initialIndex: startingIndexId,
			});
		}
	}

	function stopCurrentVideo() {
		// eslint-disable-next-line no-self-assign
		if (activeVideo) activeVideo.src = activeVideo.src;
	}

	function onToggleClick({ target }) {
		const cap = target.querySelector('.o-caption');
		if (cap.classList.contains('hidden')) {
			cap.classList.remove('hidden');
		} else {
			cap.classList.add('hidden');
		}
	}

	function onButtonClick({ target }) {
		const targetId = target.dataset.gallery;

		// Make sure we have sprig-loaded DOM references.
		mainCarouselNode = node.querySelector('[data-carousel]') ?? false;
		navCarouselNode = node.querySelector('[data-nav]') ?? false;

		// Get correct slide..
		const startingSlide = mainCarouselNode.querySelector(
			`[data-slide="${targetId}"]`
		);

		// .. and the index.
		const startingSlideId = startingSlide ? startingSlide.dataset.id : 0;

		// Open modal
		MicroModal.show('article-showcase-gallery-modal', {
			onShow: () => {
				header.style.display = 'none';
				if (mainCarousel) mainCarousel.resize();
				if (navCarousel) navCarousel.resize();

				eventBus.emit('header:lock');
			},
			onClose: () => {
				header.style.display = 'block';
				eventBus.emit('header:unlock');
				stopCurrentVideo();
			},
		});

		// .. set existing gallery slide by Index..
		if (mainCarousel && navCarousel) {
			mainCarousel.select(startingSlideId, true, true);
			navCarousel.select(startingSlideId, true, true);
		} else {
			// .. or init gallery
			initCarousel(startingSlideId);
		}
	}

	addEvents({
		'click [data-gallery]': onButtonClick,
		'click [data-caption]': onToggleClick,
	});

	// attach htmx event listeners
	if (typeof htmx !== 'undefined') {
		// initiate behaviours when sprig swaps the DOM
		htmx.on('htmx:afterSettle', ({ target }) => {
			if (target.id === 'article-showcase-gallery') {
				// initCarousel(target);
				document.body.classList.add('has-gallery');
			}
		});
	}

	device.resize(() => {
		if (mainCarousel) mainCarousel.resize();
		if (navCarousel) navCarousel.resize();
	});

	return () => {
		if (mainCarousel) mainCarousel.destroy();
		if (navCarousel) navCarousel.destroy();
	};
}

export default withPlugins(domEvents, device)(ShowcaseGalleryModal);
